module.exports = __webpack_public_path__ + "static/media/20x24no3.45993922.jpg";